import React from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import { ArrowBack as BackIcon, EmojiEvents as TrophyIcon, CastConnected as BroadcastIcon } from "@mui/icons-material";
import { HOL, holPrimaryBtnSx } from "../../../UserSide/pages/holTheme";
import HolLeaderboard from "../../../games/HolLeaderboard";
import { Eyebrow, StepShell, holGradientText, holHostPanelSx, holStageSx } from "./holHostUi";

const Stat = ({ label, value }) => (
  <Box sx={{ ...holHostPanelSx, p: 2, textAlign: "center", bgcolor: "rgba(255,255,255,0.03)" }}>
    <Typography sx={{ fontFamily: HOL.fontDisplay, fontWeight: 900, fontSize: "1.8rem", lineHeight: 1.1 }}>
      {value}
    </Typography>
    <Typography sx={{ color: HOL.muted, fontSize: "0.78rem", fontWeight: 700, letterSpacing: "0.06em" }}>
      {label}
    </Typography>
  </Box>
);

const HolFinalResults = ({ results, onDone }) => {
  const leaderboard = results?.leaderboard || [];
  const champions = leaderboard.filter((e) => e.rank === 1);

  return (
    <StepShell maxWidth={820}>
      <Box sx={{ ...holStageSx, p: { xs: 2.5, sm: 4 }, textAlign: "center" }}>
        <Eyebrow sx={{ mb: 1 }}>
          {results?.session_id ? `Session #${results.session_id} · ` : ""}Final Results
        </Eyebrow>
        <Typography
          component="h2"
          sx={{
            fontFamily: HOL.fontDisplay,
            fontWeight: 900,
            fontSize: { xs: "2.6rem", sm: "3.6rem" },
            lineHeight: 1,
            mb: 2,
            ...holGradientText,
          }}
        >
          GAME OVER
        </Typography>

        {champions.length ? (
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 1.25,
              px: 2.5,
              py: 1.25,
              mb: 3,
              borderRadius: "999px",
              bgcolor: "rgba(255,213,79,0.12)",
              border: "1px solid rgba(255,213,79,0.4)",
            }}
          >
            <TrophyIcon sx={{ color: "#ffd54f" }} />
            <Typography sx={{ fontWeight: 800, color: "#ffd54f" }}>
              {champions.length > 1 ? "Joint winners: " : "Winner: "}
              {champions.map((c) => c.display_name).join(", ")} · {champions[0].score} / {champions[0].total_rounds}
            </Typography>
          </Box>
        ) : null}

        <Grid container spacing={1.5} sx={{ mb: 3 }}>
          <Grid item xs={4}>
            <Stat label="PLAYERS JOINED" value={results?.players_joined ?? 0} />
          </Grid>
          <Grid item xs={4}>
            <Stat label="HOT SEAT RUNS" value={results?.hot_seat_runs ?? 0} />
          </Grid>
          <Grid item xs={4}>
            <Stat label="CALLS PER RUN" value={results?.rounds_per_player ?? 0} />
          </Grid>
        </Grid>

        <Box sx={{ ...holHostPanelSx, bgcolor: "rgba(0,0,0,0.25)", textAlign: "left", mb: 3 }}>
          <Typography sx={{ fontFamily: HOL.fontDisplay, fontWeight: 800, mb: 1.5, letterSpacing: "0.04em" }}>
            Leaderboard
          </Typography>
          <HolLeaderboard entries={leaderboard} />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.75, color: HOL.muted, mb: 3 }}>
          <BroadcastIcon sx={{ fontSize: 18 }} />
          <Typography sx={{ fontSize: "0.85rem" }}>
            Players are seeing GAME OVER and this leaderboard on their screens.
          </Typography>
        </Box>

        <Button variant="contained" size="large" startIcon={<BackIcon />} onClick={onDone} autoFocus sx={holPrimaryBtnSx}>
          Back to Higher or Lower
        </Button>
      </Box>
    </StepShell>
  );
};

export default HolFinalResults;
